angular.module('app.controllers').controller('AuthCheckCtrl', function ($rootScope, $state, $log, UserService, notify, $translate) {
    const redirect = () => {
        const toState = $rootScope.referenceState || 'restricted.dashboard_main';
        const toParams = $rootScope.referenceStateParams || {};

        $rootScope.referenceState = null;
        $rootScope.referenceStateParams = null;

        $log.debug('check session: redirected', toState, toParams);
        $state.go(toState, toParams);
    };

    if (UserService.isAuthenticated()) {
        redirect();
    } else {
        // sprawdzamy, czy wymuszono zapamiętanie
        const info = notify.info($translate.instant('auth.signin_check_remembered'));
        UserService.checkSessions().then(
            () => {
                info.close();
                notify.info($translate.instant('auth.signin_ok'));
                redirect();
            },
            () => {
                info.close();

                UserService.logout(() => {
                    notify.danger($translate.instant('auth.no_auth'));
                    $state.go('login', {}, { reload: true });
                });
            }
        );
    }
});
